/**
 * Countries where Stripe Connect Express accounts are supported.
 *
 * Mirror of api/src/lib/constants/stripeConnectCountries.ts — keep in sync.
 * The API re-validates server-side, so the FE list is for UX only.
 */

export interface StripeConnectCountry {
  code: string
  name: string
}

export const STRIPE_CONNECT_COUNTRIES: StripeConnectCountry[] = [
  { code: 'AU', name: 'Australia' },
  { code: 'AT', name: 'Austria' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BR', name: 'Brazil' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'CA', name: 'Canada' },
  { code: 'HR', name: 'Croatia' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'DK', name: 'Denmark' },
  { code: 'EE', name: 'Estonia' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'France' },
  { code: 'DE', name: 'Germany' },
  { code: 'GR', name: 'Greece' },
  { code: 'HK', name: 'Hong Kong' },
  { code: 'HU', name: 'Hungary' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IT', name: 'Italy' },
  { code: 'JP', name: 'Japan' },
  { code: 'LV', name: 'Latvia' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MT', name: 'Malta' },
  { code: 'MX', name: 'Mexico' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'NO', name: 'Norway' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'RO', name: 'Romania' },
  { code: 'SG', name: 'Singapore' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'ES', name: 'Spain' },
  { code: 'SE', name: 'Sweden' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'TH', name: 'Thailand' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'US', name: 'United States' },
]

export const STRIPE_CONNECT_COUNTRY_CODES: ReadonlySet<string> = new Set(
  STRIPE_CONNECT_COUNTRIES.map((c) => c.code),
)

export function isStripeConnectSupported(countryCode: string | null | undefined): boolean {
  if (!countryCode) return false
  return STRIPE_CONNECT_COUNTRY_CODES.has(countryCode.toUpperCase().trim())
}

export function getCountryName(countryCode: string | null | undefined): string {
  if (!countryCode) return ''
  const code = countryCode.toUpperCase().trim()
  return STRIPE_CONNECT_COUNTRIES.find((c) => c.code === code)?.name || code
}
